import { OrganizationRole, type Role } from '@/enums/roles';
import type { Organization as OrganizationType } from '@/types/organization';
import { hasOverlap } from '@/utils/array';

/** Checks if the given employee has the given role(s) in the organization provided or any of its parent orgs */
export function hasAccessToOrg(
    employeeId: string,
    requiredRoles: OrganizationRole[],
    organization: OrganizationType,
    parentOrganizations: OrganizationType[]
): boolean {
    const hierarchicalAllowedRoles = getHierarchicalAllowedRoles(requiredRoles);
    let currentOrg: OrganizationType | undefined = organization;

    while (currentOrg != null) {
        const orgEmployee = currentOrg?.employees.find((oe) => oe.employee.toString() == employeeId.toString());

        if (hasOverlap(hierarchicalAllowedRoles, orgEmployee?.roles ?? [])) return true;

        currentOrg = parentOrganizations.find((o) => o._id.toString() == currentOrg?.parent?.toString());
    }

    return false;
}

function getHierarchicalAllowedRoles(allowedRoles: Role[]): OrganizationRole[] {
    const roleValues = Object.values(OrganizationRole);
    const highestRoleIndex = Math.max(...allowedRoles.map((r) => roleValues.findIndex((rv) => rv === r)));

    const roles = roleValues.filter((_, index) => index <= highestRoleIndex);

    // TODO: remove EmployeeReadonly role implementation, it doesnt exist anymore.
    if (roles.includes(OrganizationRole.Employee)) roles.push(OrganizationRole.EmployeeReadOnly);

    return roles;
}
